import angular from 'angular';
import ordersComponent from './orders.component';
import OrdersService from './orders.service';
import ordersConfig from './orders.config';
import SyncOrderModalController from './sync-order-modal/sync-order-modal.controller';
import orderDetailModule from './order-detail/order-detail';

let ordersModule = angular.module('app.orders',[orderDetailModule.name])
  .component('orders', ordersComponent)
  .controller('SyncOrderModalController', SyncOrderModalController)
  .service('OrdersService', OrdersService)
  .config(ordersConfig);

export default ordersModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/orders/orders.js
 **/